window.addEventListener("DOMContentLoaded", () => {

  let form_being_submitted = false;
  const checkForm = function checkForm(e) {
    const reset_button = document.getElementById("reset-button");
    if(form_being_submitted) {
      e.preventDefault();
      return;
    }
    e.submitter.disabled = true;
    reset_button.classList.remove("d-none");
    form_being_submitted = true;
  };

  const resetForm = function resetForm() {
    this.classList.add("d-none");
    const form = document.getElementById("form-download-codes");
    form.querySelector('button[type="submit"]').disabled = false;
    form_being_submitted = false;
  };

  const downloadCodesButton = document.getElementById('form-download-codes');
  if (downloadCodesButton) {
    downloadCodesButton.addEventListener('submit', checkForm, false);
  }
  const resetButton = document.getElementById('reset-button');
  if (resetButton) {
    resetButton.addEventListener('click', resetForm, false);
  }

  const disableDownloadButton = function disableDownloadButton(e) {
    const form = e.target;
    form.download_invoices.disabled = true;
    const reset_button = document.getElementById("reset-invoice-button");
    reset_button.classList.remove("d-none");
  }

  const resetInvoiceForm = function resetInvoiceForm() {
    this.classList.add("d-none");
    const form = document.getElementById("form-download-invoice");
    form.querySelector('button[type="submit"]').disabled = false;
  };

  const downloadInvoiceButton = document.getElementById('form-download-invoice');
  if (downloadInvoiceButton) {
    downloadInvoiceButton.addEventListener('submit', disableDownloadButton, false);
  }
  const resetInvoiceButton = document.getElementById('reset-invoice-button');
  if (resetInvoiceButton) {
    resetInvoiceButton.addEventListener('click', resetInvoiceForm, false);
  }

}, false);
